export function rfc6570ToReactRouterScheme(path: string): string {
  return path
    .split('{')
    .map(part => part.replace('}', ''))
    .join(':');
}
